module.exports = {
    success: require('./competition-success'),
    submitted: require('./competition-submitted'),
    start: require('./competition-start'),
    abandoned: require('./competition-abandoned'),
    disallowParticipate: require('./competition-disallow')
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/atmmapper/competition.js
 **/